import React from "react";

const SearchIcon = () => (
  <svg className="rc-lp__section-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
    <circle cx="6" cy="6" r="3.5" stroke="currentColor" strokeWidth="1.3" />
    <path d="M8.5 8.5L11.5 11.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

const ClientIcon = () => (
  <svg className="rc-lp__section-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
    <circle cx="7" cy="5" r="2.5" stroke="currentColor" strokeWidth="1.3" />
    <path d="M2.5 12c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

const ConfirmIcon = () => (
  <svg className="rc-lp__section-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
    <path d="M4 3.5h6v1H4zM4 6h6M4 8h4" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
    <rect x="2.5" y="2" width="9" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.3" />
    <path d="M5 9l1.5 1.5L9 8" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const LinkIcon = () => (
  <svg className="rc-lp__section-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
    <path d="M5.5 8.5a3 3 0 004.243 0l1.414-1.414a3 3 0 00-4.243-4.243L6.086 4.18" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    <path d="M8.5 5.5a3 3 0 00-4.243 0L2.843 6.914a3 3 0 004.243 4.243L7.914 9.82" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

const AssignSellRequestsIcon = () => (
  <svg
    className="rc-lp__section-icon"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden
  >
    <path
      d="M3 9.5L6.5 6L9 8.5L11.5 6"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="3" cy="9.5" r="1" fill="currentColor" />
    <circle cx="11.5" cy="6" r="1" fill="currentColor" />
  </svg>
);

const PaymentsIcon = () => (
  <svg
    className="rc-lp__section-icon"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden
  >
    <rect
      x="2"
      y="4"
      width="10"
      height="7"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.3"
    />
    <path
      d="M2 6.5h10"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

const InvoiceIcon = () => (
  <svg
    className="rc-lp__section-icon"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden
  >
    <path
      d="M3.5 2h7v10l-1.75-1L7 12l-1.75-1L3.5 12V2z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 5h3M5.5 7h3"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);

const TrackingIcon = () => (
  <svg
    className="rc-lp__section-icon"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden
  >
    <rect
      x="2"
      y="4.5"
      width="6.5"
      height="5"
      stroke="currentColor"
      strokeWidth="1.3"
    />
    <path
      d="M8.5 6.5h2.5l1 2v1H8.5z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <circle cx="4.5" cy="10.5" r="1.2" stroke="currentColor" strokeWidth="1.3" />
    <circle cx="10" cy="10.5" r="1.2" stroke="currentColor" strokeWidth="1.3" />
  </svg>
);

const SendQuoteIcon = () => (
  <svg
    className="rc-lp__section-icon"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden
  >
    <path
      d="M12 2L1.5 6.5l4 1.5 1.5 4L12 2z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
      fill="currentColor"
      fillOpacity="0.25"
    />
  </svg>
);

const PxSummaryIcon = () => (
  <svg
    className="rc-lp__section-icon"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden
  >
    <path
      d="M2 7h4M8 7h4M3 4l3 3-3 3M11 10l-3-3 3-3"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CommissionsIcon = () => (
  <svg
    className="rc-lp__section-icon"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden
  >
    <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.3" />
    <path
      d="M7 4.5v5M5.5 7h3"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

const CostsIcon = () => (
  <svg
    className="rc-lp__section-icon"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden
  >
    <rect x="2" y="3" width="10" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.3" />
    <path d="M4.5 6h5M4.5 8h3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

const SerialIcon = () => (
  <svg
    className="rc-lp__section-icon"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden
  >
    <rect x="2" y="4" width="10" height="6" stroke="currentColor" strokeWidth="1.3" />
    <path d="M4 5.5v3M5.5 5.5v3M7 5.5v3M8.5 5.5v3M10 5.5v3" stroke="currentColor" strokeWidth="1" />
  </svg>
);

const DocIcon = () => (
  <svg
    className="rc-lp__section-icon"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden
  >
    <path
      d="M3 1.5h6l3 3V12a.5.5 0 01-.5.5h-8A.5.5 0 013 12V1.5z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <path d="M5 6h4M5 8h4M5 10h2.5" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
  </svg>
);

const PoIcon = () => (
  <svg
    className="rc-lp__section-icon"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden
  >
    <path d="M2 3.5h10v7H2z" stroke="currentColor" strokeWidth="1.3" />
    <path d="M4 6h6M4 8h4" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
  </svg>
);

const PublishIcon = () => (
  <svg
    className="rc-lp__section-icon"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden
  >
    <path
      d="M7 11V3M4 6l3-3 3 3"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.5 12h9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

const ICONS = {
  search: SearchIcon,
  client: ClientIcon,
  confirm: ConfirmIcon,
  link: LinkIcon,
  assign: AssignSellRequestsIcon,
  payments: PaymentsIcon,
  invoice: InvoiceIcon,
  tracking: TrackingIcon,
  sendQuote: SendQuoteIcon,
  pxSummary: PxSummaryIcon,
  commissions: CommissionsIcon,
  costs: CostsIcon,
  serial: SerialIcon,
  doc: DocIcon,
  po: PoIcon,
  publish: PublishIcon,
};

// Bare section icon, same vocabulary as the trigger — the flow rail's mobile
// markers reuse it so a section's icon is identical everywhere (payments is
// ALWAYS the card, search always the magnifier, …).
export const SectionIcon = ({ icon = "search" }) => {
  const Icon = ICONS[icon] || SearchIcon;
  return <Icon />;
};

export const SectionTrigger = ({ label, icon = "search" }) => {
  const Icon = ICONS[icon] || SearchIcon;
  return (
    <span className="search-product-trigger-label">
      <Icon />
      <span>{label}</span>
    </span>
  );
};
